import { DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material"
import SubmitButton from "./button/SubmitButton"
import { useDispatch } from 'react-redux'
import { closeModal } from "../store/actions/modalAction"
import { useState } from "react"

const MessageDilog = ({ title = "Error", message, onSubmit }) => {
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)
    const handleClose = () => {
        dispatch(closeModal())
    }
    const handleSubmit = async (e)=>{
        e.preventDefault();
        setLoading(true);
        onSubmit ? await onSubmit(e) : handleClose();
    }
    return (
        <>
            <DialogTitle variant="h3">{title}</DialogTitle>
            <DialogContent>
                <DialogContentText variant="h4" id="alert-dialog-slide-description">
                    {message}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <SubmitButton onClick={handleClose} title={'close'}></SubmitButton>
                <SubmitButton loading={loading} onClick={(e)=>handleSubmit(e)} title="okay" ></SubmitButton>
            </DialogActions>

        </>
    )
}
export default MessageDilog